import {
  type GLTF,
  GLTFLoader
} from "three/examples/jsm/loaders/GLTFLoader.js";

const loader = new GLTFLoader();

export async function parseGltfFile(file: File): Promise<GLTF> {
  return loader.parseAsync(await file.arrayBuffer(), "");
}
